import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Segment, Divider } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloBotones } from "../../../estilos/botones";
import { estiloColores } from "../../../estilos/colores";
import { apiViaje } from "../../../api/viaje";
import Swal from "sweetalert2";
import { ENTORNO } from "../../../utils/constantes";
import { getrole } from "../../../utils/variablesLocales";
import HomeIcon from "@mui/icons-material/Home";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Alert from "@mui/material/Alert";
import logoLocalPoint from "../../../imagenes/logoConNombre.png";

const apiviaje = new apiViaje();

const ImportarArchivo = async (Archivo) => {
  try {
    if (Archivo === null) {
      Swal.fire({
        title: "Error!",
        text: "Archivo. Requerido",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: estiloColores.Gris,
      });
    } else {
      const respuesta = await apiviaje.importarResultadoBanco(Archivo);
      if (respuesta.status === 200) {
        Swal.fire({
          title: "",
          text: "Archivo importado correctamente",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: estiloColores.Azul,
        }).then(function () {});
      } else {
        Swal.fire({
          title: "Error!",
          text: "Error al importar archivo",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: estiloColores.Gris,
        });
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export function ImportarBanco() {
  const [yaCargo, setyaCargo] = useState(false);

  const [Archivo, setArchivo] = useState("");

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        if (!yaCargo) {
          setyaCargo(true);
          setArchivo(null);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();

  const navigateToInicio = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <AppBar style={{ background: "#DC030E" }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              onClick={navigateToInicio}
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Importar de banco
            </Typography>
            <img
              src={logoLocalPoint}
              style={{ marginTop: "1px" }}
              width="75"
              alt="Logo"
            />
          </Toolbar>
        </AppBar>
        <Segment style={estiloSegmento.Administrador}>
          <Form>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Form.Field>
              <label>Archivo (CSV)</label>
              <input
                placeholder="Selecciona archivo"
                type="file"
                onChange={(e) => {
                  setArchivo(e.target.files[0]);
                }}
              />
            </Form.Field>

            <Alert severity="info">
              El archivo es de formato CSV y contiene el resultado de las
              transferencias de dinero a los conductores
            </Alert>

            <Divider />
            <Form.Group>
              <Form.Button
                name="Importar"
                style={estiloBotones.GuardarCambios}
                onClick={() => {
                  ImportarArchivo(Archivo);
                }}
              >
                Importar
              </Form.Button>
            </Form.Group>
          </Form>
        </Segment>
      </div>
    </div>
  );
}
